<template>
  <input
      type="checkbox"
      @click="checkedHandler($event)"
      :checked="parseInt(params.value)"
  />
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: 'CellRendererCheckbox',
  methods: {
    checkedHandler(event) {
      const checked = event.target.checked;
      const colId = this.params.column.colId;

      // Appending a true/false boolean with + casts it to an integer
      // giving us a 1/0 boolean. This is useful here as the setDataValue expect
      // a numeric value.
      this.params.node.setDataValue(colId, +checked);
    }
  }
});
</script>
